
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import Collection from "../components/collection/Collection";

import axios from "axios";

function HomePg () {

    const[loading, setLoading] = useState(true);
    const [homeData, setData] = useState([]);

    const URL = "https://madadoo.kreatistheweb.com/api/v2/";


    useEffect(() => {
        axios.get(`${URL}`)
            .then(response => {
                setData(response.data);
                setLoading(false);
            });
    }, []);

    //show the loader when waiting data
    if(loading) {    
        return <span className="load-bar container"></span>;
    }


    return (
        <>
        {/* <section className="section">              
            <div className="container text-center">
                <h1>Madadoo Shop</h1>
                
            </div>
        </section> */}
        {/* <section className="section collection-loop">
            {homeData.collections? 
            homeData.collections.map((collection) => <Collection collection={collection} key={collection.id} />) :
            'Not thing for instance...'
            }
        </section> */}

        <section className="section collection-loop">
            {
                homeData.collections?
                homeData.collections.map((collection) => <Collection collection={collection} key={collection.id} />) :
                ''
            }
        </section>
        </>
    );

}

export default HomePg;